<template>
  <div class="space-y-4">
    <div class="bg-ontick-graphite-500 space-y-6 rounded px-4 py-6 shadow sm:p-10">
      <h2 class="text-lg font-bold sm:text-2xl">
        Antes de começar, precisamos saber se você possui cadastro na OnTick Invest.
      </h2>
      <div class="relative flex flex-col space-y-2">
        <label for="cpf" class="text-sm text-gray-400"> Digite seu CPF </label>
        <div class="relative w-full">
          <input
            name="cpf"
            type="text"
            v-mask="'###.###.###-##'"
            placeholder="Ex.: 123.456.789-01"
            v-model="cpf"
            class="bg-ontick-steel-500 w-full rounded border-0 shadow focus:outline-none"
            :class="
              cpfIsValid || formattedCpf.length !== 11
                ? 'focus:ring-ontick-blue-600 focus:ring-1'
                : 'ring-ontick-red-600 focus:ring-ontick-red-600 ring-2 focus:ring-2 '
            "
            v-validate="'required|length:11'"
          />
          <div class="absolute top-1/2 right-2 -translate-y-1/2" v-if="loading && cpfIsValid">
            <i v-html="$icons.loading" class="text-ontick-blue-600"></i>
          </div>
        </div>
        <div class="min-h-[20px]">
          <span v-if="!cpfIsValid && cpfLength === 11" class="text-ontick-red-600 text-sm"> CPF inválido </span>
          <template v-else-if="!loading">
            <span v-if="cpfIsValid && userExists" class="text-ontick-green-600 text-sm">
              Esse CPF está cadastrado na OnTick Invest.
            </span>
            <span v-else-if="cpfIsValid && !userExists" class="text-ontick-yellow-600 text-sm">
              Esse CPF não está cadastrado na OnTick Invest. Avance para fazer seu cadastro.
            </span>
          </template>
        </div>
      </div>
    </div>
    <div class="flex w-full items-center justify-end">
      <transition name="fade">
        <button
          v-if="cpfIsValid && cpfLength === 11 && !loading"
          @click="checkUser(formattedCpf)"
          class="text-ontick-carbon-900 bg-ontick-blue-600 w-full rounded py-2 px-12 text-sm font-semibold shadow filter transition-all hover:brightness-125 sm:w-auto"
        >
          {{ userExists ? "Avançar" : "Fazer cadastro" }}
        </button>
      </transition>
    </div>
  </div>
</template>

<script>
import { v4 } from "uuid";
import axios from "axios";
import { Encrypt, Decrypt } from "../../../shared/utils/encrypt";
export default {
  data() {
    return {
      cpf: "",
      userExists: false,
      cpfIsValid: false,
      loading: false,
      show: false,
    };
  },

  computed: {
    cpfLength() {
      return this.formattedCpf.length;
    },
    formattedCpf() {
      return this.cpf.replaceAll(".", "").replaceAll("-", "");
    },
  },

  methods: {
    validarCPF(cpf) {
      return new Promise((resolve) => {
        cpf = cpf.replace(/[^\d]+/g, "");
        if (cpf == "") resolve(false);
        // Elimina CPFs invalidos conhecidos
        if (
          cpf.length != 11 ||
          cpf == "00000000000" ||
          cpf == "11111111111" ||
          cpf == "22222222222" ||
          cpf == "33333333333" ||
          cpf == "44444444444" ||
          cpf == "55555555555" ||
          cpf == "66666666666" ||
          cpf == "77777777777" ||
          cpf == "88888888888" ||
          cpf == "99999999999"
        )
          resolve(false);
        // Valida 1o digito
        let add = 0;
        for (let i = 0; i < 9; i++) add += parseInt(cpf.charAt(i)) * (10 - i);
        let rev = 11 - (add % 11);
        if (rev == 10 || rev == 11) rev = 0;
        if (rev != parseInt(cpf.charAt(9))) resolve(false);
        // Valida 2o digito
        add = 0;
        for (let i = 0; i < 10; i++) add += parseInt(cpf.charAt(i)) * (11 - i);
        rev = 11 - (add % 11);
        if (rev == 10 || rev == 11) rev = 0;
        if (rev != parseInt(cpf.charAt(10))) resolve(false);
        resolve(true);
      });
    },
    checkUser(cpf) {
      return new Promise((resolve, reject) => {
        let uuid = v4();

        let uuidKey = "".padStart(32, uuid.slice(0, 4));
        let cpfKey = "".padStart(32, cpf.slice(0, 4));

        let payload = {
          user_cpf: cpf,
          uuidv4: uuid,
        };

        let data = {
          user_cpf: cpf,
          p: Encrypt(JSON.stringify(payload), cpfKey),
        };

        let config = {
          headers: {
            authorization: uuid,
          },
          params: {
            hash: Encrypt(uuid, uuidKey),
          },
        };

        axios
          .post(this.$endpoint.CHECK_USER, data, config)
          .then((res) => {
            // console.log(res);
            this.userExists = true;
            resolve(res);
          })
          .catch((err) => {
            console.error(err);
            this.userExists = false;
            reject(err);
          });
      });
    },
  },

  watch: {
    formattedCpf: {
      handler(val) {
        if (val.length === 11) {
          this.loading = true;
          this.validarCPF(val).then((isValid) => {
            if (isValid) {
              this.cpfIsValid = true;
              this.checkUser(val).finally(() => {
                this.loading = false;
              });
            }
          });
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.fade {
  &-enter,
  &-leave-to {
    @apply scale-125 opacity-0;
  }
  &-enter-active,
  &-leave-active {
    @apply transition-all duration-500 ease-in-out;
  }
}
</style>
